import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsExports from './amplify/aws-exports';

Amplify.configure(awsExports);

// Safety net for any promise rejection (e.g. a blocked/aborted network request)
// that isn't caught at its own call site. Without this, WebKit surfaces such a
// rejection as an uncaught pageerror while Chromium/Firefox merely warn to the
// console - this listener makes the outcome identical across engines.
window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  console.error('Unhandled promise rejection:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
